import { DEMO_INPUT } from './demoAssets';

function ImageUploader({ onGenerate }) {
  return (
    <section className="hero-shell sample-flow" aria-labelledby="upload-title">
      <div className="hero-copy">
        <p className="eyebrow">Sample 2D to 3D prototype</p>
        <h1 id="upload-title">Convert the Sample Image Into an Interactive 3D Model</h1>
        <p>
          The sample image is already selected. Click Convert to 3D to run the
          mocked conversion sequence and open the provided GLB model.
        </p>
      </div>

      <div className="upload-panel sample-panel">
        <button
          className="sample-dropzone is-selected"
          type="button"
          aria-pressed="true"
          aria-label="Selected sample 2D image"
        >
          <span className="upload-icon" aria-hidden="true">
            ^
          </span>
          <img src={DEMO_INPUT} alt="Sample 2D input object" />
          <strong>Sample image selected</strong>
        </button>

        <button className="button primary-button" type="button" onClick={onGenerate}>
          Convert to 3D
        </button>
      </div>
    </section>
  );
}

export default ImageUploader;
